import "./TopOutfits.css";
import "../components/fonts.css";
import clothers_hanger from "../assets/clothes-hanger.svg";
import dashboard from "../assets/dashboard.svg";
import dollar from "../assets/dollar.svg";
import Connected_header from "../components/connected_header.js";
import React, { useEffect, useState } from "react";
import Top from "./Top.js";
import Activity from "./Activity.js";

function TopOutfits() {
  const [selectedText, setSelectedText] = useState("VENTES");
  const [selectedGenre, setSelectedGenre] = useState("TOP#");
  const [userData, setUserData] = useState(null);

  const handleTextClick = (text) => {
    setSelectedText(text);
  };

  const handleGenreClick = (text) => {
    setSelectedGenre(text);
  };

  https: useEffect(() => {
    // token saved from the login response is passed here in the header
    const token = localStorage.getItem("jwtToken");
    if (token) {
      fetch(
        "https://happer-test.francecentral.cloudapp.azure.com/api/users/me",
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => setUserData(data))
        .catch((error) => console.error(error));
    } else {
      console.log("No token found !!!!");
    }
  }, []);

  return (
    <>
      {userData ? (
        <Connected_header
          name={userData.last_name + ". " + userData.first_name.slice(0, 1)}
        />
      ) : (
        <Connected_header name={"User"} />
      )}
      <div className="TopOutfits">
        <div className="Drawer">
          <div className="drawer_element">
            <img className="drawer_image" src={dollar} alt="heart" />
            <h4
              onClick={() => handleTextClick("VENTES")}
              className="Drawer_text"
            >
              VENTES
            </h4>
          </div>
          <div className="drawer_element">
            <img className="drawer_image" src={dashboard} alt="heart" />
            <h4
              onClick={() => handleTextClick("ACTIVITY")}
              className="Drawer_text"
            >
              ACTIVITY
            </h4>
          </div>
          {/* <div className="drawer_element">
            <img className="drawer_image" src={clothers_hanger} alt="heart" />
            <h4
              onClick={() => handleTextClick("GESTION")}
              className="Drawer_text"
            >
              GESTION
            </h4>
          </div> */}
          <div className="space"></div>
{/*           <button className="Upload_button">+UPLOAD</button>
 */}        </div>
        <div className="devider_div" />
        <div className="content_div">
          {selectedText === "VENTES" ? (
            <>
              <div className="tab_div">
                <h4
                  onClick={() => handleGenreClick("TOP#")}
                  className="Genre_text"
                >
                  TOP#
                </h4>
                {/*  <h4
                  onClick={() => handleGenreClick("DONNEES")}
                  className="Genre_text"
                >
                  DONNEES
                </h4>
                <h4
                  onClick={() => handleGenreClick("FEEDBACKS")}
                  className="Genre_text"
                >
                  FEEDBACKS
                </h4> */}
              </div>
              <div className="devider_div2" />
              <div className="tab_body">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  {selectedGenre === "TOP#" ? (
                    <Top />
                  ) : selectedGenre === "DONNEES" ? (
                    <>
                      <p>donnees</p>
                    </>
                  ) : (
                    <>
                      <p>feedbacks</p>
                    </>
                  )}
                </div>
              </div>
            </>
          ) : selectedText === "ACTIVITY" ? (
            <>
              <Activity />
            </>
          ) : (
            <>
              <h1>Gestion page</h1>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default TopOutfits;
